// extracted by mini-css-extract-plugin
export default {"buttonBase":"ButtonBase_buttonBase__EsEEe","logOut":"ButtonBase_logOut__taShF","text":"ButtonBase_text__obnq-"};